<template>
  <div class="upload-container">
    <!-- <el-upload
      action="#"
      :show-file-list="false"
      multiple
      :http-request="uploadNewPhoto"
    >
      <el-button size="small" type="primary">上传新图片</el-button>
    </el-upload> -->
  </div>
</template>

<script>
import PickPhotoAlert from '@/components/Upload/PickPhotoAlert';
import PickVideoAlert from '@/components/Upload/PickVideoAlert';
import { getToken } from '../../../utils/auth';
import { uploadPicture } from '@/api/fileUpload';

export default {
  name: 'editorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff',
    },
  },
  components: { PickPhotoAlert, PickVideoAlert },
  data() {
    return {
      dialogVisible: false,
      videoDialogVisible: false,
      listObj: {},
      fileList: [],
      dataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
      },
      header: { token: getToken() },
    };
  },
  methods: {
    // checkAllSuccess() {
    //   return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess)
    // },
    uploadNewPhoto(item) {
      let formData = new FormData();
      formData.append('file', item.file);
      uploadPicture(formData, getToken())
        .then((resp) => {
          let originArray = [];
          originArray.push(resp.data);
          this.$emit('successCBK', originArray);
        })
        .catch((error) => {
          this.$message.error('上传失败，请重新上传');
          console.log('报错', error);
        });
    },
    handleSubmit() {
      // const arr = Object.keys(this.listObj).map(v => this.listObj[v])
      // if (!this.checkAllSuccess()) {
      //   this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
      //   return
      // }
      // console.log(arr);
      // this.$emit('successCBK', arr);
      // this.listObj = {};
      // this.fileList = [];
      // this.dialogVisible = false;
      let originArray = this.$refs.pickPhotoAlertRef.chooseList;
      console.log(originArray);
      this.$emit('successCBK', originArray);
      this.dialogVisible = false;
    },
    handleVideoSubmit() {
      // const arr = Object.keys(this.listObj).map(v => this.listObj[v])
      // if (!this.checkAllSuccess()) {
      //   this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
      //   return
      // }
      // console.log(arr);
      // this.$emit('successCBK', arr);
      // this.listObj = {};
      // this.fileList = [];
      // this.dialogVisible = false;
      let originArray = this.$refs.pickVideoAlertRef.chooseList;
      this.$emit('successCBK', originArray);
      this.videoDialogVisible = false;
    },
    // handleSuccess(response, file) {
    //
    //   const uid = file.uid;
    //   const objKeyArr = Object.keys(this.listObj)
    //   for (let i = 0, len = objKeyArr.length; i < len; i++) {
    //     if (this.listObj[objKeyArr[i]].uid === uid) {
    //       // this.listObj[objKeyArr[i]].url = this.dataObj.host + '/' + this.dataObj.dir + '/' + file.name;
    //         this.listObj[objKeyArr[i]].url = response.data
    //         this.listObj[objKeyArr[i]].hasSuccess = true
    //       return
    //     }
    //   }
    // },
    // handleRemove(file) {
    //   const uid = file.uid;
    //   const objKeyArr = Object.keys(this.listObj);
    //   for (let i = 0, len = objKeyArr.length; i < len; i++) {
    //     if (this.listObj[objKeyArr[i]].uid === uid) {
    //       delete this.listObj[objKeyArr[i]];
    //       return
    //     }
    //   }
    // },
    // beforeUpload(file) {
    //   // const _self = this
    //   const fileName = file.uid;
    //   this.listObj[fileName] = {hasSuccess: false, uid: file.uid, width: this.width, height: this.height};
    //   // this.listObj[fileName] = {};
    //   // return new Promise((resolve, reject) => {
    //   //   policy().then(response => {
    //   //     _self.dataObj.policy = response.data.policy;
    //   //     _self.dataObj.signature = response.data.signature;
    //   //     _self.dataObj.ossaccessKeyId = response.data.accessKeyId;
    //   //     _self.dataObj.key = response.data.dir + '/${filename}';
    //   //     _self.dataObj.dir = response.data.dir;
    //   //     _self.dataObj.host = response.data.host;
    //   //     _self.listObj[fileName] = {hasSuccess: false, uid: file.uid, width: this.width, height: this.height};
    //   //     resolve(true)
    //   //   }).catch(err => {
    //   //     console.log(err)
    //   //     reject(false)
    //   //   })
    //   // })
    // }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.upload-container .editor-slide-upload {
  margin-bottom: 20px;
}
</style>
